import { render, staticRenderFns } from "./FeatureAttribute.vue?vue&type=template&id=2b939d24&scoped=true"
import script from "./FeatureAttribute.vue?vue&type=script&lang=js"
export * from "./FeatureAttribute.vue?vue&type=script&lang=js"
import style0 from "./FeatureAttribute.vue?vue&type=style&index=0&id=2b939d24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b939d24",
  null
  
)

export default component.exports